<template>
  <v-form @submit.prevent="syncData" ref="form">
    <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">New Holidays for {{fiscal_period.fiscalYear}}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog" :disabled="disabled">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text>
            <p v-if="error" style="color:red;">{{ errorMessage }}</p>    
            <v-alert :value="true" color="info" icon="info" outline style="margin-top:10px;" dismissible>
                There are {{holidays_new.length}} new holidays for {{fiscal_period.fiscalYear}}.
            </v-alert>   
            <v-data-table
                    :headers="headers"
                    :items="holidays_new"
                >
                    <template v-slot:items="props">
                        <tr @click="props.expanded = !props.expanded" title="Click to Edit" style="cursor:pointer;">
                            <td>{{ props.item.date | moment("YYYY-MM-DD (ddd)") }}</td>
                            <td>{{ props.item.description }}</td>
                            <td>{{ props.item.holidayTypeName }}</td>
                        </tr>
                    </template>
                </v-data-table> 
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions style="height:45px">
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :loading="loading" style="color:white">
                <v-icon dark>sync</v-icon>&nbsp;&nbsp;Sync&nbsp;&nbsp;
            </v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>

import holidaysApi from '@/api/holidays'

export default {
    data () {
        return {
            error: false,
            errorMessage: '', 
            loading: false,
            error: false,
            headers: [
                {text: 'Holiday Date',align: 'left',value: '',width: '30%', sortable:true},
                {text: 'Holiday Name',align: 'left',value: '',width: '35%', sortable:false},
                {text: 'Holiday Type',align: 'left',value: '',width: '35%', sortable:false},
            ],
            holidays_new: [],
            fiscal_period: null
      }
    },
    methods: {
        setParams(data, fiscal_period){
            this.holidays_new = data
            this.fiscal_period = fiscal_period
        },
        closeDialog() {
            this.$emit('update:dialogNew', false)
        },
        async syncData() {
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    await holidaysApi.sync(this.fiscal_period.fiscalPeriodId)
                    this.loading = false
                    this.closeDialog()
                    this.$emit('send', '')
                }catch(error) {
                    this.errorMessage = error
                    this.error = true
                }
            }
        },
    },
    computed: {},
    created() {}
}
</script>